<template>
  <footer>
    <div class="container">
      <div class="footer-top">
        <div class="footer-left">
          <h3>携手广校通<br>共建智慧校园新未来</h3>
          <p>如果您对我们的产品与解决方案感兴趣，<br>欢迎与我们的业务经理联系，我们将为您提供专业服务</p>
          
          <div class="company-info">
            <!-- <div class="company-logo">
             

               <img class="logo-text" src="/src/assets/logo.png" alt="">
            </div> -->
            <div class="company-details">
             
      <p>
        <img src="@/assets/icon-logo.png" alt="广校通" class="footer-logo">
        <span class="company-name">中广互联科技（广州）有限公司</span>
      </p>
      <p>
        <img src="@/assets/icon-location.png" alt="" class="footer-icon">
        <span>广州市黄埔区科珠路232号益科智能创新园2栋5楼</span>
      </p>
      <p>
        <img src="@/assets/icon-phone.png" alt="" class="footer-icon">
        <span>020-82038386</span>
      </p>
      <p>
        <img src="@/assets/icon-email.png" alt="" class="footer-icon">
        <span>yijiazniy@126.com</span>
      </p>
    
            </div>
          </div>
        </div>
        
        <div class="footer-right">
          <div class="contact-card">
            <div class="contact-info">
              <span class="label">业务经理</span>
              <h4>纪 经理</h4>
              <p>
                <span class="icon-phone"> 
                  <img class="iconbox" src="@/assets/icon-phone.png" alt="">
                </span>
                181 4285 9545
              </p>
              <p>
                <span class="icon-email">
                  <img class="iconbox" src="@/assets/icon-email.png" alt="">
                </span>
                yijiazniy@126.com
              </p>
            </div>
            <div class="qr-code">
              <!-- 在这里添加微信二维码 -->
              <div class="qr-placeholder">
                
                   <img class="iconbox2" src="@/assets/icon-qr.png" alt="">
                
                <!-- <span class="qr-text">微信扫码联系</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
         
      <div class="rowrow1">
        <div>中广互联科技（广州）有限公司版权所有@2022-2024<span id="newest_year"></span>
			<a href="https://beian.miit.gov.cn/">粤ICP备2023020584号-1</a>
        </div>
      
    </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
footer {
  background: #1a1f24;
  color: #fff;
  padding: 60px 0 30px;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 50px;
  gap: 60px;
}

.footer-left {
  flex: 1;
}

.footer-left h3 {
  font-size: 28px;
  margin-bottom: 15px;
  line-height: 1.4;
  font-weight: 600;
}

.footer-left > p {
  font-size: 15px;
  color: #ffffff;
  margin-bottom: 30px;
  line-height: 1.8;
}

.company-info {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.company-logo {
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.logo-text {
  width: 125px;
  height: 45px;
  /* font-size: 18px;
  font-weight: 600;
  color: #fff; */
}

.company-details {
  flex: 1;
}

.company-details p {
  font-size: 15px;
  color: #99a3b3;
  margin-bottom: 8px;
  line-height: 1.6;
  display: flex;
  align-items: center;
  gap: 8px;
}

.company-details p:first-child {
  color: #fff;
  font-size: 14px;
  margin-bottom: 12px;
}

/* 图标占位符 - 您可以用真实图标替换 */
.icon-location,
.icon-phone,
.icon-email,
.icon-qr {
  display: inline-block;
  width: 20px;
  height: 20px;
  /* background: #99a3b3; */
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
}

/* 如果您使用图标库，可以这样替换：
.icon-location::before { content: '📍'; }
.icon-phone::before { content: ''; }
.icon-email::before { content: '✉'; }
*/

.footer-right {
  flex-shrink: 0;
}

.contact-card {
  background: #242b33;
  padding: 75px 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 40px;
  min-width: 450px;
}

.contact-info {
  flex: 1;
}

.contact-info .label {
  font-size: 13px;
  color: #99a3b3;
  display: block;
  margin-bottom: 8px;
}

.contact-info h4 {
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: 600;
}

.contact-info p {
  font-size: 14px;
  color: #99a3b3;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-info p:nth-child(3) {
  color: #6bb3d9;
  font-size: 16px;
  font-weight: 500;
}

.qr-code {
  flex-shrink: 0;
}

.qr-placeholder {
  width: 110px;
  height: 110px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
}

.qr-text {
  font-size: 12px;
  color: #333;
  text-align: center;
}

.footer-bottom {
  border-top: 1px solid #2a3240;
  padding-top: 25px;
  text-align: center;
}

.footer-bottom .rowrow1 {
  font-size: 15px;
  color: #ffffff;
  margin-bottom: 8px;
  line-height: 1.6;
}

.footer-bottom p:last-child {
  margin-bottom: 0;
}
.iconbox{
  width: 20px;
  height: 20px;
}
.iconbox2{
  width: 110px;
  height: 110px;
}

/* 响应式 */
@media (max-width: 1024px) {
  .footer-top {
    flex-direction: column;
    gap: 40px;
  }
  
  .contact-card {
    min-width: auto;
    width: 100%;
  }
  
  .company-info {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }
  
  .footer-left h3 {
    font-size: 24px;
  }
  
  .contact-card {
    flex-direction: column;
    padding: 25px;
    gap: 25px;
  }
  
  .footer-bottom p {
    font-size: 12px;
  }
}
.company-info {
  /* background: #1e2530;  */
  /* padding: 30px 0; */
}

.company-details p {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #a0aec0; /* 浅灰色文字 */
  margin-bottom: 12px;
  line-height: 1.6;
}

.company-details p:last-child {
  margin-bottom: 0;
}

/* .footer-bottom p:first-child {
  display: flex;
  align-items: center;
  gap: 10px;
} */

.footer-logo {
  width: 80px;
  height: 20px;
  object-fit: contain;
}

.company-name {
  color: #e2e8f0;
  font-weight: 500;
}
.footer-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  object-fit: contain;
  /* 如果图标是黑色，可以添加滤镜变成白色/浅色 */
  /* filter: brightness(0) invert(1); */
}


/* 响应式 */
@media (max-width: 768px) {
  .company-info {
    padding: 20px 0;
  }
  
  .company-details p {
    font-size: 13px;
    margin-bottom: 10px;
  }
  
  .footer-icon,
  .footer-logo {
    width: 14px;
    height: 14px;
  }
}
</style>